// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3iHbC","buttons":"RemoveExpirationActionButtons_buttons__2dSNN"};